import React, { useEffect } from "react";
import "../PrivacyPolicy/styles.css";
import "./styles.css";

const SDK_HEADERS = [
  "第三方SDK名称",
  "合作方主体",
  "功能目的",
  "使用场景",
  "个人信息类型",
  "收集方式",
  "隐私政策或官网链接",
];

const API_HEADERS = [
  "第三方API名称",
  "合作方主体",
  "功能目的",
  "使用场景",
  "个人信息类型",
  "收集方式",
  "隐私政策或官网链接",
];

const SDK_ROWS = [
  // {
  //   name: "灵机SDK",
  //   partner: "合肥灵机一动智能科技有限公司",
  //   purpose: "智能设备的连接、控制和管理",
  //   scene: "在用户对智能设备进行查看和管理时使用",
  //   personalInfo: [
  //     "设备信息：设备标识符、IP 地址、无线连接信息、操作系统类型和版本、应用程序版本号、推送通知标识符、日志文件和移动网络信息。",
  //     "日志数据：SDK 的性能数据，例如 MQTT 连接率，Socket 连接率等脱敏的业务数据。",
  //   ],
  //   collectionMethod: "SDK采集",
  //   link: "http://xjadmin.xjiangiot.com/file/xjcloud/8293d1a9d8c5449f9b5d9a04c430e5bf.html",
  // },
  {
    name: "微信Open SDK",
    partner: "深圳市腾讯计算机系统有限公司",
    purpose: "微信账号登录",
    scene: "在用户使用微信登录时使用",
    personalInfo: [
      "用户主动选择的微信头像、昵称信息；",
      "仅Android、HarmonyOS：验证设备是否安装微信APP；",
      "仅iOS：调用剪切板权限，实现第三方应用与微信间的数据传输",
    ],
    collectionMethod: "SDK采集",
    link: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8",
  },
  {
    name: "移动推送-android",
    partner: "杭州阿里云智能科技有限公司",
    purpose: "实现App消息推送功能，确保App在关闭或后台运行状态下可正常接收推送通知",
    scene: "向用户发送消息推送通知时使用；应用处于后台或关闭状态时通过自启动/关联启动能力接收广播消息",
    personalInfo:
      "设备标识信息（Android ID、OAID、IDFA/IDFV）、推送令牌（Push Token）、IP地址、操作系统类型及版本、应用版本号、移动网络信息",
    collectionMethod: "SDK采集",
    link: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.434217.0.0.6f663e68ZeueeL",
  },
  {
    name: "OPPO PUSH 客户端SDK",
    partner: "广东欢太科技有限公司",
    purpose: "通过OPPO厂商推送通道向OPPO/OnePlus设备用户下发推送消息",
    scene: "在OPPO/OnePlus设备上进行消息推送时使用",
    personalInfo:
      "设备标识符（Android ID、OAID、IMEI）、运营商信息、网络信息、推送注册ID（Registration ID）",
    collectionMethod: "SDK采集",
    link: "https://open.oppomobile.com/new/developmentDoc/info?id=11228",
  },
  {
    name: "vivo推送SDK",
    partner: "维沃移动通信有限公司",
    purpose: "通过vivo厂商推送通道向vivo设备用户下发推送消息",
    scene: "在vivo设备上进行消息推送时使用",
    personalInfo:
      "设备标识符（IMEI、Android ID、vivo Push RegID）、运营商信息、网络信息",
    collectionMethod: "SDK采集",
    link: "https://dev.vivo.com.cn/documentCenter/doc/878",
  },
  {
    name: "小米推送",
    partner: "北京小米移动软件有限公司",
    purpose: "通过小米厂商推送通道向小米/Redmi设备用户下发推送消息",
    scene: "在小米/Redmi设备上进行消息推送时使用",
    personalInfo:
      "设备标识符（OAID、Android ID、小米推送RegID）、运营商信息、网络信息",
    collectionMethod: "SDK采集",
    link: "https://dev.mi.com/console/doc/detail?pId=1822",
  },
  {
    name: "性能加速库",
    partner: "华为软件技术有限公司",
    purpose: "华为HMS核心基础库，提供设备性能加速能力，是华为推送通道的基础依赖",
    scene: "在华为/荣耀设备上集成华为推送服务时作为底层依赖使用",
    personalInfo:
      "设备信息（硬件信息、操作系统信息）、性能统计数据",
    collectionMethod: "SDK采集",
    link: "https://developer.huawei.com/consumer/cn/doc/development/graphics-Guides/sdk-data-security-0000001050700772",
  },
  {
    name: "荣耀推送SDK",
    partner: "深圳荣耀软件技术有限公司",
    purpose: "通过荣耀厂商推送通道向荣耀设备用户下发推送消息",
    scene: "在荣耀设备上进行消息推送时使用",
    personalInfo:
      "设备标识符（Android ID、推送令牌）、网络信息、操作系统信息",
    collectionMethod: "SDK采集",
    link: "https://developer.honor.com/cn/docs/11002/guides/sdk-data-security",
  },
  {
    name: "魅族推送SDK",
    partner: "珠海星纪魅族信息技术有限公司",
    purpose: "通过魅族厂商推送通道向魅族设备用户下发推送消息",
    scene: "在魅族设备上进行消息推送时使用",
    personalInfo:
      "设备标识符（设备唯一标识、推送令牌）、网络信息、操作系统信息",
    collectionMethod: "SDK采集",
    link: "https://open.flyme.cn/docs?id=202",
  },
  // {
  //   name: "阿里云 ARMS 用户体验监控 SDK",
  //   partner: "阿里云计算有限公司",
  //   purpose: "用于应用性能监控、错误监控、接口请求链路分析、异常排查",
  //   scene: "App 启动后初始化；用于监控 JS 错误、控制台错误、接口请求性能和稳定性",
  //   personalInfo:
  //     "用户信息（如配置用户标识时）、应用信息、设备信息、流量信息、设备状态信息、网络状态信息；结合当前项目，还会采集接口请求与错误日志信息",
  //   collectionMethod: "SDK采集",
  //   link: "https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240308104330389/20240308104330389.html",
  // },
];

const API_ROWS = [
  {
    name: "阿里云 OSS API",
    partner: "阿里云计算有限公司",
    purpose: "文件、图片、音频、视频上传与访问，生成预签名链接",
    scene: "用户上传头像、宠物动态图片/视频、音频、知识库附件时使用",
    personalInfo:
      "上传文件内容、文件名、对象路径、访问 URL，文件中可能包含用户图片、语音、视频信息",
    collectionMethod: "接口传输",
    link: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201811151455_40246.html",
  },
  {
    name: "阿里云短信服务 API",
    partner: "阿里云计算有限公司",
    purpose: "发送短信",
    scene: "手机号登录、验证码发送时使用",
    personalInfo: "手机号、短信模板参数（验证码等）",
    collectionMethod: "接口传输",
    link: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201811151455_40246.html",
  },
  {
    name: "阿里云内容安全 Green API",
    partner: "阿里云计算有限公司",
    purpose: "图片、视频、文本内容审核",
    scene: "宠物动态、上传内容审核时使用",
    personalInfo: "待审核图片/视频对象名、文本内容、业务标识",
    collectionMethod: "接口传输",
    link: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201811151455_40246.html",
  },
  {
    name: "阿里云百炼 / 通义千问 API",
    partner: "阿里云计算有限公司",
    purpose: "对话生成、多模态理解、知识库召回重排、文本向量化",
    scene: "AI 聊天、图片内容提取、向量检索时使用",
    personalInfo: "用户对话文本、上下文消息、图片 URL",
    collectionMethod: "接口传输",
    link: "https://help.aliyun.com/zh/model-studio/privacy-notice",
  },
  {
    name: "阿里云 FunASR API",
    partner: "阿里云计算有限公司",
    purpose: "音频转文字",
    scene: "用户上传语音后识别文本时使用",
    personalInfo: "音频文件 URL、音频内容、转写文本",
    collectionMethod: "接口传输",
    link: "https://help.aliyun.com/zh/model-studio/privacy-notice",
  },
  // {
  //   name: "灵机API",
  //   partner: "合肥灵机一动智能科技有限公司",
  //   purpose: "第三方账号同步、获取 IoT Token、设备绑定联动",
  //   scene: "用户登录灵机能力、设备绑定/解绑联动时使用",
  //   personalInfo: "本系统用户 Token、灵机 Token、用户 ID、设备 SN、设备 ID、绑定状态",
  //   collectionMethod: "接口传输",
  //   link: "https://www.ljyd.cn",
  // },
];

function renderCellContent(value) {
  if (Array.isArray(value)) {
    return value.map((line) => (
      <p key={line} className="sharing-table-cell-paragraph">
        {line}
      </p>
    ));
  }

  return value;
}

function SharingTable({ headers, rows }) {
  return (
    <div className="sharing-table-wrap">
      <table className="sharing-table">
        <colgroup>
          <col className="col-name" />
          <col className="col-partner" />
          <col className="col-purpose" />
          <col className="col-scene" />
          <col className="col-info" />
          <col className="col-method" />
          <col className="col-link" />
        </colgroup>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.name}>
              <td data-label={headers[0]}>{row.name}</td>
              <td data-label={headers[1]}>{row.partner}</td>
              <td data-label={headers[2]}>{row.purpose}</td>
              <td data-label={headers[3]}>{row.scene}</td>
              <td data-label={headers[4]}>{renderCellContent(row.personalInfo)}</td>
              <td data-label={headers[5]}>{row.collectionMethod}</td>
              <td data-label={headers[6]}>
                <a
                  href={row.link}
                  target="_blank"
                  rel="noreferrer"
                  className="policy-link"
                >
                  {row.link}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function PersonalInfoSharingList() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="privacy-policy-page personal-info-sharing-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>个人信息共享清单</h1>

      <p>
        当您使用第三方提供的服务时，我们会在获得或确保第三方获得您的授权同意后，以及其他符合法律法规规定的情形下共享对应信息。您可以通过本清单中列举的相关信息了解第三方会如何处理你的个人信息。我们也会对第三方获取个人信息的行为进行严格约束，以保护您的个人信息安全。
      </p>
      <p>
        为保障伴知宠APP服务的相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）或应用程序接口（API）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）或应用程序接口（API）进行严格的安全评估，以保护您的个人信息安全。以下是我们接入的主要的第三方服务商的信息：
      </p>

      <h2>第三方SDK列表：</h2>
      <SharingTable headers={SDK_HEADERS} rows={SDK_ROWS} />

      <h2>第三方API列表：</h2>
      <SharingTable headers={API_HEADERS} rows={API_ROWS} />
    </div>
  );
}
